import React from 'react';

const LoadingIndicator = ({ type = 'default', className = '', text = 'Загрузка...' }) => {
    const baseClass = 'loading-indicator';
    
    if (type === 'image') {
        return (
            <div className={`${baseClass} ${baseClass}--image ${className}`}>
                <div className={`${baseClass}__spinner`}>
                    <div className={`${baseClass}__spinner-circle`}></div>
                </div>
                <span className={`${baseClass}__text`}>{text}</span>
            </div>
        );
    }
    
    if (type === 'text') {
        return (
            <div className={`${baseClass} ${baseClass}--text ${className}`}>
                <div className={`${baseClass}__spinner ${baseClass}__spinner--small`}>
                    <div className={`${baseClass}__spinner-circle`}></div>
                </div>
                <span className={`${baseClass}__text`}>{text}</span>
            </div>
        );
    }
    
    return (
        <div className={`${baseClass} ${className}`}>
            <div className={`${baseClass}__spinner`}>
                <div className={`${baseClass}__spinner-circle`}></div>
            </div>
            <span className={`${baseClass}__text`}>{text}</span>
        </div>
    );
};

export default LoadingIndicator;
